import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { IPDService } from '../Services/ipdServices.service';
import { EMRService } from 'app/EMR/EMR.service';
import { AuthService } from 'app/auth/auth.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';

@Component({
  selector: 'app-otconsent',
  templateUrl: './otconsent.component.html',
  styleUrls: ['./otconsent.component.scss']
})
export class OTConsentComponent implements OnInit {
  Otconsentdata: any = [];
  constructor(public opdvisitService:OpdVisitService, public authService:AuthService, public emrservice:EMRService, public ipdService:IPDService, public dashboardService:DashboardService, public dialogRef: MatDialogRef<OTConsentComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,) { 
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.getOtConsent();
  }
  closedialog(){
    this.dialogRef.close();
    localStorage.removeItem('pateintdetail');
    localStorage.removeItem('branchMasterobj');
    localStorage.removeItem('site');
    localStorage.removeItem('pdfURL');
    
    
  }

  getOtConsent() {
    
    this.ipdService.getOTconstent(0, 'OTConcent').subscribe(
      (x: any) => {
        this.Otconsentdata = [];
        if (x.length > 0) {
          this.Otconsentdata = x;
        }
      },
      (err) => {
        this.dashboardService.openSnackBar("API FAILED", "OK");
      }
    );
  }
  otconsentUrl: any;
  getreport(element) {
    this.otconsentUrl = "";
    if (element.pK_DocumentId) {
     
      this.emrservice
        .getImagedata(
          element.pK_DocumentId,
          this.authService.Loggeduser.branchid,
          element.documentType
        )
        .subscribe(
          (data: any) => {
        
            if (data != null && data != undefined && data.length > 0) {
              let checknull = data.filter((item) => item != null);
              this.otconsentUrl =
                this.opdvisitService.mainUrl +
                element.documentType +
                "/" +
                checknull[0];
            } else {
              this.otconsentUrl = "";
            }
           this.printOTconsent();
          },
          (err) => {}
        );
      //  window.open(this.reporturl + 'SurgicalConsentmaster.aspx?DocumentId=' + docid + '&DocumentName=' + docName + '&IpdID=' + this.selectIpdId + '&RegID=' + this.RegId + '&ConsID=' + this.consId + '&BranchId=' + this.authService.Loggeduser.branchid + '&PageHeadWebReport=' + this.PageHeader + '&OTType=' + doctype + '&BillingCompanyName=' + this.authService.Loggeduser.billingcompanyname);
    } else {
      this.dashboardService.openSnackBar("Please Select Bill ", "OK");
    }
  }

  printOTconsent() {
  
    localStorage.setItem(
      "pateintdetail",
      JSON.stringify(this.opdvisitService.patientdetails)
    );
    localStorage.setItem(
      "branchMasterobj",
      JSON.stringify(this.dashboardService.branchmansterObj)
    );
    localStorage.setItem("site", this.data.eyetype);
    localStorage.setItem("pdfURL", this.otconsentUrl);
    window.open(
      window.location.origin + "/print-otconsent".toString(),
      "mypopup",
      "resizable=no, toolbar=no, scrollbars=no, menubar=no, status=no, directories=no, location=no, width=1000, height=600, left=10 top=100"
    );
  }
}
